import { createSelector } from 'reselect';

import { IApplicationState } from '../../types/redux';

interface ISelectionSourceState {
  map: Pick<IApplicationState['map'], 'selection'>;
}

const selectSelection = (state: ISelectionSourceState) => state.map.selection;

/** realtyId офферов пина, выбранного на карте. Единственный источник - state.map.selection. */
export const selectPreviewRealtyIds = createSelector(selectSelection, (selection): number[] =>
  selection ? selection.feature.properties.offers.map(offer => offer.realtyId) : [],
);
